<template lang="pug">
  .smartlynq-dashboard(v-if="shouldShowGenerativeFaq")
    .floating-faq-container(v-if="!useWebchatSmartLynq")
      .btn-container(:class="{'active': isOpenState}")
        .aiq-button(@click="toggleWindow")
            img.logo(:src="returnToggleButtonSrc")
      .generative-query-container(v-if="isOpenState")
        .generative-query-header
          .left Chat With SmartLynq
        .generative-query-body
          GenerativeFaq
</template>

<script>
import * as log from 'loglevel';
import isEmpty from 'lodash/isEmpty';
import { mapState } from 'vuex';
import logo from '@/assets/bot.png';
import logoClosed from '@/assets/close-icon.svg';
import GenerativeFaq from './GenerativeFaq.vue';

export default {
  name: 'FloatingFaq',

  components: {
    // Deprecating: Do not add code into dashboard
    GenerativeFaq,
  },

  computed: {
    ...mapState({
      isOpenState: state => state.genAi.isOpenState,
      FEATURE_FLAGS: state => state.featureFlags.FEATURE_FLAGS,
      token: state => state.agent.aclToken,
    }),
    returnToggleButtonSrc() {
      if (this.isOpenState) return logoClosed;
      return logo;
    },
    shouldShowGenerativeFaq() {
      return this.FEATURE_FLAGS.GENERATIVE_FAQ;
    },
    useWebchatSmartLynq() {
      return this.FEATURE_FLAGS.WEBCHAT_SMARTLYNQ;
    },
  },
  mounted() {
    if (this.shouldShowGenerativeFaq && this.useWebchatSmartLynq) {
      const env = process.env.ENVIRONMENT;
      if (isEmpty(env)) {
        throw Error(`Environment variable is not set but trying to load smartlynq: ${env}`);
      }

      const url = `https://chat-service.${env}.agentiq.co/webchat.js?product=smartlynq&auto_render=false`;

      log.debug('SmartLynq for webchat mounted:', url);
      const smartLynqToken = this.token;
      (function(src) {
        return new Promise((resolve, reject) => {
          // If already loaded, skip
          if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
          }

          const script = document.createElement('script');
          script.src = src;
          script.async = true;

          script.onload = () => {
            window.__aiq.chat_theme = { primary: 'red', secondary: '#434566' };
            window.__aiq.bubble = {
              open: {
                background_color: '#152E53',
              },
              close: {
                background_color: '#152E53',
              },
            };
            window.__aiq.smartlynq_token = smartLynqToken;
            window.__aiq.renderChat();
            resolve();
          };
          script.onerror = () => reject(new Error(`Failed to load: ${src}`));

          document.head.appendChild(script);

          log.info('SmartLynq script added to document:', src);
        });
      })(url);
    }
  },

  methods: {
    async toggleWindow() {
      await this.$store.dispatch('genAi/updateWindowState', !this.isOpenState);
    },

    async closeWindow() {
      await this.$store.dispatch('genAi/updateWindowState', false);
    },
  },
};
</script>

<style lang="scss" scoped>
    .floating-faq-container {
      position: absolute;
      height: 0px;
      right: 0;
      bottom: 0;
      z-index: 1066;
      .btn-container {
        position: fixed;
        right: 20px;
        bottom: 20px;
        height: 60px;
        width: 60px;
        display: flex;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -webkit-box-shadow: 0px 4px 40px rgba(0,0,0,.46);
        -moz-box-shadow: 0px 4px 40px rgba(0,0,0,.46);
        box-shadow: 0 4px 40px #00000075;
        -webkit-transition: background-color .5s;
        -moz-transition: background-color .5s;
        -o-transition: background-color .5s;
        transition: background-color .5s;
        border-radius: 100%;
        overflow: hidden;
        background-color: #152E53;
        &:hover, &.active {
          background-color: #4671B3;
        }
        .aiq-button{
          position: relative;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 50%
          }
        }
      }
      .generative-query-container{
        position: fixed;
        max-width: 350px;
        background: white;
        right: 20px;
        bottom: 98px;
        max-height: 80vh;
        min-height: 200px;
        height: calc(100% - 100px);
        width: calc(100% - 20px);
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        -webkit-box-shadow: 0px 4px 40px rgba(0,0,0,.16)!important;
        -moz-box-shadow: 0px 4px 40px rgba(0,0,0,.16)!important;
        box-shadow: 0 4px 40px #00000029!important;
        .generative-query-header{
          align-items: center;
          display: flex;
          position: relative;
          background-color: #4671B3;
          height: 3.25rem;
          color: white;
          .left{
            margin: auto;
          }
          .right{
            position: absolute;
            right: 10px;
            .right-button {
              height: 50px;
              margin-right: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .generative-query-body {
          height: calc(100% - 3.25rem);
          position: relative;
          padding: 15px 0 15px 0;
          box-sizing: border-box;
        }
      }
    }
</style>
